import React from "react";

const BusinessOpportunity = () => {
  const scrollDown = () => {
    window.scrollBy({ top: 500, left: 0, behavior: "smooth" });
  };
  return (
    <div className="bg-gray-50 pt-36 pb-20" data-aos="fade-down">
      <div className="bg-gray-50 px-6 md:px-16">
        <div className="xl:max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-8">
          {/* Text Section */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            {/* <h2 className="text-lg">
              START GETTING NEW BUSINESS OPPORTUNITIES
            </h2> */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mt-4 leading-tight">
              Where Opportunities Meet Efficiency for Gig Workers
            </h1>
            <p className="text-gray-400 mt-4 text-base md:text-lg leading-relaxed">
              Empowering installation partners with seamless access to
              high-value projects, real-time updates, and streamlined workflows.
              Maximize your opportunities while ensuring efficiency and
              hassle-free payments.
            </p>

            <button onClick={scrollDown} className="mt-6 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg">
              Know More →
            </button>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end items-center relative">
            <img
              src="/assests/images/LandingPage/IP/ipImage1.webp"
              alt="Business"
              className=" md:w-150 xl:w-[35rem]  rounded-lg transform translate-x-4 translate-y-8"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessOpportunity;
